import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"
import _imports_0 from '@/assets/images/percentage90.png'
import _imports_1 from '@/assets/images/percentage90@2x.png'
import _imports_2 from '@/assets/images/card.png'
import _imports_3 from '@/assets/images/card@2x.png'
import _imports_4 from '@/assets/images/trade.png'
import _imports_5 from '@/assets/images/trade@2x.png'
import _imports_6 from '@/assets/images/message.png'
import _imports_7 from '@/assets/images/message@2x.png'


const _hoisted_1 = _imports_1 + ' 2x'
const _hoisted_2 = _imports_3 + ' 2x'
const _hoisted_3 = _imports_5 + ' 2x'
const _hoisted_4 = _imports_7 + ' 2x'
const _hoisted_5 = { class: "top" }
const _hoisted_6 = { class: "steps" }
const _hoisted_7 = { class: "items" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_layout = _resolveComponent("layout")!

  return (_openBlock(), _createBlock(_component_layout, {
    onHandleNext: _ctx.handleNext,
    current: 3,
    prePathName: "confirm",
    preBtnShow: !_ctx.isShowSkip
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_5, [
        _cache[1] || (_cache[1] = _createElementVNode("img", {
          src: _imports_0,
          srcset: _hoisted_1,
          alt: ""
        }, null, -1)),
        _cache[2] || (_cache[2] = _createElementVNode("div", null, "最后一步，通过银行转账完成开户", -1)),
        (!_ctx.isShowSkip)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "btn-skip",
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.skip && _ctx.skip(...args)))
            }, "跳过"))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_6, [
        _cache[3] || (_cache[3] = _createElementVNode("div", { class: "icons" }, [
          _createElementVNode("img", {
            src: _imports_2,
            srcset: _hoisted_2,
            alt: ""
          }),
          _createElementVNode("div", { class: "line" }),
          _createElementVNode("img", {
            src: _imports_4,
            srcset: _hoisted_3,
            alt: ""
          }),
          _createElementVNode("img", {
            src: _imports_6,
            srcset: _hoisted_4,
            alt: ""
          }),
          _createElementVNode("div", { class: "line" })
        ], -1)),
        _createElementVNode("div", _hoisted_7, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.steps, (item) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "step-item",
              key: item.title
            }, [
              _createElementVNode("div", null, _toDisplayString(item.title), 1),
              _createElementVNode("div", null, _toDisplayString(item.remark), 1)
            ]))
          }), 128))
        ])
      ])
    ]),
    _: 1
  }, 8, ["onHandleNext", "preBtnShow"]))
}